import FieldDefinition from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { getFieldValue } from "@store/Store/Pages/CreateAccountForm/CreateAccountFormSelectors";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import FormTextField, { formTextFieldFieldDefinitions } from "@store/Widgets/CreateAccount/FieldTypes/FormTextField";
import { FieldsObj } from "@store/Widgets/CreateAccount/FieldTypes/SelectWithOtherOption";
import React, { FC } from "react";
import { connect } from "react-redux";

const fieldKey = "firstName";

interface OwnProps extends WidgetProps {
    fields: FieldsObj;
}

const mapStateToProps = (state: StoreApplicationState) => ({
    value: getFieldValue(state, fieldKey),
});
type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const CreateAccountFirstName: FC<Props> = ({ fields, value }) => {
    return <FormTextField fields={fields} value={value} valueKey={fieldKey} type="text" />;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CreateAccountFirstName),
    definition: {
        group: "Create Account" as any,
        displayName: "First Name",
        icon: "input-pipe",
        fieldDefinitions: formTextFieldFieldDefinitions(
            "First Name",
            "Enter your first name",
            true,
        ) as FieldDefinition[],
    },
};

export default widgetModule;
